module.exports = __webpack_public_path__ + "../static/img/integrations_logo.fc750b8e.png";